import React from "react";
import { I18n } from "../../../../models/I18n";
import style from "./style/ReportSummarySection.module.scss";

export interface ReportSummarySectionProps {
    basedOn: string;
    title: string;
    handle: string;
    scrollToSection?: (elementId: string) => void;
    showViewAll?: boolean;
    i18n: I18n;
    classes?: {
        titleDecoration: string;
    }
}

const ReportSummarySection = ({
    basedOn,
    title,
    children,
    handle,
    showViewAll = false,
    scrollToSection,
    i18n,
    classes,
}: React.PropsWithChildren<ReportSummarySectionProps>) => {
    return (
        <div className={style.sectionWrapper}>
            <div className={style.titleSection}>
                <h4>{title}</h4>
                <p>{basedOn}</p>
                <div className={classes && classes.titleDecoration}></div>
            </div>
            {children}
            {
                showViewAll && (
                    <p onClick={() => scrollToSection ? scrollToSection(handle) : null} data-testid="view-all" data-section={handle}>
                        {i18n.report_management_summary_view_all}
                    </p>
                )
            }
        </div>
    );
};

export default ReportSummarySection;
